import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=ffd8acf6&"
import script from "./FormButtons.vue?vue&type=script&lang=js&"
export * from "./FormButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffd8acf6')) {
      api.createRecord('ffd8acf6', component.options)
    } else {
      api.reload('ffd8acf6', component.options)
    }
    module.hot.accept("./FormButtons.vue?vue&type=template&id=ffd8acf6&", function () {
      api.rerender('ffd8acf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-form/components/FormButtons.vue"
export default component.exports